export default {
	"status": {
		"runtime": {
			"completed": true
		},
		"errors": {
			"data": {
				"code": "",
				"description": ""
			}
		}
	},
	"response": {
		"data": [
			{
				"title": "Macine",
				"image": "https://static.mulinobianco.it/v3/pew/COLLECTION_COLAZIONE_2022/assets/img/prodotti/macine.png",
				"description": "350g - 800g - 1kg",
				"link":"macine"
			},
			{
				"title": "Tarallucci",
				"image": "https://static.mulinobianco.it/v3/pew/COLLECTION_COLAZIONE_2022/assets/img/prodotti/tarallucci.png",
				"description": "350g - 800g - 1kg",
				"link":"tarallucci"
			},
			{
				"title": "Galletti",
				"image": "https://static.mulinobianco.it/v3/pew/COLLECTION_COLAZIONE_2022/assets/img/prodotti/galletti.png",
				"description": "350g - 800g - 1kg",
				"link":"galletti"
			},
			{
				"title": "Abbracci",
				"image": "https://static.mulinobianco.it/v3/pew/COLLECTION_COLAZIONE_2022/assets/img/prodotti/abbracci.png",
				"description": "350g - 700g - 1kg",
				"link":"abbracci"
			},
			{
				"title": "Ritornelli",
				"image": "https://static.mulinobianco.it/v3/pew/COLLECTION_COLAZIONE_2022/assets/img/prodotti/ritornelli.png",
				"description": "350g - 800g - 1kg",
				"link":"ritornelli"
			},
			{
				"title": "Nascondini",
				"image": "https://static.mulinobianco.it/v3/pew/COLLECTION_COLAZIONE_2022/assets/img/prodotti/nascondini.png",
				"description": "350g - 800g - 1kg",
				"link":"nascondini"
			},
			{
				"title": "Baiocchi",
				"image": "https://static.mulinobianco.it/v3/pew/COLLECTION_COLAZIONE_2022/assets/img/prodotti/baiocchi.png",
				"description": "260g",
				"link":"baiocchi"
			},
			{
				"title": "Campagnole",
				"image": "https://static.mulinobianco.it/v3/pew/COLLECTION_COLAZIONE_2022/assets/img/prodotti/campagnole.png",
				"description": "350g - 800g - 1kg",
				"link":"campagnole"
			},
			{
				"title": "Girotondi",
				"image": "https://static.mulinobianco.it/v3/pew/COLLECTION_COLAZIONE_2022/assets/img/prodotti/girotondi.png",
				"description": "350g - 800g - 1kg",
				"link":"girotondi"
			},
			{
				"title": "Batticuori",
				"image": "https://static.mulinobianco.it/v3/pew/COLLECTION_COLAZIONE_2022/assets/img/prodotti/batticuori.png",
				"description": "350g - 800g - 1kg",
				"link":"batticuori"
			},
			{
				"title": "Scacchieri",
				"image": "https://static.mulinobianco.it/v3/pew/COLLECTION_COLAZIONE_2022/assets/img/prodotti/scacchieri.png",
				"description": "300g",
				"link":"scacchieri"
			},
			{
				"title": "Schiaccianoci",
				"image": "https://static.mulinobianco.it/v3/pew/COLLECTION_COLAZIONE_2022/assets/img/prodotti/schiaccianoci.png",
				"description": "350g - 800g - 1kg",
				"link":"schiaccianoci"
			},
			{
				"title": "Rigoli",
				"image": "https://static.mulinobianco.it/v3/pew/COLLECTION_COLAZIONE_2022/assets/img/prodotti/rigoli.png",
				"description": "350g - 800g - 1kg",
				"link":"rigoli"
			},
			{
				"title": "Biscottone",
				"image": "https://static.mulinobianco.it/v3/pew/COLLECTION_COLAZIONE_2022/assets/img/prodotti/biscottone.png",
				"description": "350g - 800g - 1kg",
				"link":"biscottone"
			},
			{
				"title": "Pannocchie",
				"image": "https://static.mulinobianco.it/v3/pew/COLLECTION_COLAZIONE_2022/assets/img/prodotti/pannocchie.png",
				"description": "350g - 800g - 1kg",
				"link":"pannocchie"
			},
			{
				"title": "Cuordimela",
				"image": "https://static.mulinobianco.it/v3/pew/COLLECTION_COLAZIONE_2022/assets/img/prodotti/cuordimela.png",
				"description": "350g - 800g - 1kg",
				"link":"cuor-di-mela"
			},
			{
				"title": "Spicchi di sole",
				"image": "https://static.mulinobianco.it/v3/pew/COLLECTION_COLAZIONE_2022/assets/img/prodotti/spicchidisole.png",
				"description": "350g - 800g - 1kg",
				"link":"spicchi-di-sole"
			},
			{
				"title": "Settembrini",
				"image": "https://static.mulinobianco.it/v3/pew/COLLECTION_COLAZIONE_2022/assets/img/prodotti/settembrini.png",
				"description": "350g - 800g - 1kg",
				"link":"seetembrini"
			},
			{
				"title": "Lentille",
				"image": "https://static.mulinobianco.it/v3/pew/COLLECTION_COLAZIONE_2022/assets/img/prodotti/lentille.png",
				"description": "350g - 800g - 1kg",
				"link":"lentille"
			},
			{
				"title": "Cecille",
				"image": "https://static.mulinobianco.it/v3/pew/COLLECTION_COLAZIONE_2022/assets/img/prodotti/cecille.png",
				"description": "350g - 800g - 1kg",
				"link":"cecille"
			},
			{
				"title": "Molinetti",
				"image": "https://static.mulinobianco.it/v3/pew/COLLECTION_COLAZIONE_2022/assets/img/prodotti/molinetti.png",
				"description": "350g - 800g - 1kg",
				"link":"molinetti"
			},
			{
				"title": "Cioccograno",
				"image": "https://static.mulinobianco.it/v3/pew/COLLECTION_COLAZIONE_2022/assets/img/prodotti/cioccograno.png",
				"description": "350g",
				"link":"cioccograno"
			},
			{
				"title": "Primizie",
				"image": "https://static.mulinobianco.it/v3/pew/COLLECTION_COLAZIONE_2022/assets/img/prodotti/primizie.png",
				"description": "350g - 800g - 1kg",
				"link":"primizie"
			},
			{
				"title": "Buongrano",
				"image": "https://static.mulinobianco.it/v3/pew/COLLECTION_COLAZIONE_2022/assets/img/prodotti/buongrano.png",
				"description": "350g - 800g - 1kg",
				"link":"buongrano"
			},
			{
				"title": "PandiYò",
				"image": "https://static.mulinobianco.it/v3/pew/COLLECTION_COLAZIONE_2022/assets/img/prodotti/pandiYo.png",
				"description": "350g - 800g - 1kg",
				"link":"pandiyo"
			},
			{
				"title": "Cioccofrolle",
				"image": "https://static.mulinobianco.it/v3/pew/COLLECTION_COLAZIONE_2022/assets/img/prodotti/cioccofrolle.png",
				"description": "350g - 800g - 1kg",
				"link":"cioccofrolle"
			},
			{
				"title": "Cioccoavena",
				"image": "https://static.mulinobianco.it/v3/pew/COLLECTION_COLAZIONE_2022/assets/img/prodotti/cioccoavena.png",
				"description": "350g - 800g - 1kg",
				"link":"cioccoavena"
			},
			{
				"title": "Zenzerini",
				"image": "https://static.mulinobianco.it/v3/pew/COLLECTION_COLAZIONE_2022/assets/img/prodotti/zenzerini.png",
				"description": "350g - 800g - 1kg",
				"link":"zenzerini"
			},
			{
				"title": "Plumcake classico",
				"image": "https://static.mulinobianco.it/v3/pew/COLLECTION_COLAZIONE_2022/assets/img/prodotti/plumcake_classico.png",
				"description": "350g - 800g - 1kg",
				"link":"plumcake-classico"
			},
			{
				"title": "Plumcake cioccolato",
				"image": "https://static.mulinobianco.it/v3/pew/COLLECTION_COLAZIONE_2022/assets/img/prodotti/plumcake_cioccolato.png",
				"description": "350g - 800g - 1kg",
				"link":"plumcake-gocce-di-cioccolato"
			},
			{
				"title": "Pancake",
				"image": "https://static.mulinobianco.it/v3/pew/COLLECTION_COLAZIONE_2022/assets/img/prodotti/pancake.png",
				"description": "350g - 800g - 1kg",
				"link":"pancake"
			},
			{
				"title": "Nastrine",
				"image": "https://static.mulinobianco.it/v3/pew/COLLECTION_COLAZIONE_2022/assets/img/prodotti/nastrine.png",
				"description": "350g - 800g - 1kg",
				"link":"nastrine"
			},
			{
				"title": "Nastrine al cioccolato",
				"image": "https://static.mulinobianco.it/v3/pew/COLLECTION_COLAZIONE_2022/assets/img/prodotti/nastrine_cioccolato.png",
				"description": "350g - 800g - 1kg",
				"link":"nastrine-cioccolato"
			},
			{
				"title": "Cornetti classici",
				"image": "https://static.mulinobianco.it/v3/pew/COLLECTION_COLAZIONE_2022/assets/img/prodotti/cornetti_classici.png",
				"description": "350g - 800g - 1kg",
				"link":"cornetti-classici"
			},
			{
				"title": "Cornetti cioccolato",
				"image": "https://static.mulinobianco.it/v3/pew/COLLECTION_COLAZIONE_2022/assets/img/prodotti/cornetti_cioccolato.png",
				"description": "350g - 800g - 1kg",
				"link":"cornetti-cioccolato"
			},
			{
				"title": "Cornetti crema",
				"image": "https://static.mulinobianco.it/v3/pew/COLLECTION_COLAZIONE_2022/assets/img/prodotti/cornetti_crema.png",
				"description": "350g - 800g - 1kg",
				"link":"cornetti-crema"
			},
			{
				"title": "Cornetti albicocca",
				"image": "https://static.mulinobianco.it/v3/pew/COLLECTION_COLAZIONE_2022/assets/img/prodotti/cornetti_albicocca.png",
				"description": "350g - 800g - 1kg",
				"link":"cornetti-albicocca"
			},
			{
				"title": "Nastrine integrali",
				"image": "https://static.mulinobianco.it/v3/pew/COLLECTION_COLAZIONE_2022/assets/img/prodotti/nastrine_integrali.png",
				"description": "350g - 800g - 1kg",
				"link":"nastrine-integrali"
			},
			{
				"title": "Cornetti integrali",
				"image": "https://static.mulinobianco.it/v3/pew/COLLECTION_COLAZIONE_2022/assets/img/prodotti/cornetti_integrali.png",
				"description": "350g - 800g - 1kg",
				"link":"cornetti-integrali"
			},
			{
				"title": "Plumcake integrali",
				"image": "https://static.mulinobianco.it/v3/pew/COLLECTION_COLAZIONE_2022/assets/img/prodotti/plumcake_integrali.png",
				"description": "350g - 800g - 1kg",
				"link":"plumcake-integrale"
			},
			{
				"title": "Cornetti integrali nocciola",
				"image": "https://static.mulinobianco.it/v3/pew/COLLECTION_COLAZIONE_2022/assets/img/prodotti/cornetti_integrali_nocciola.png",
				"description": "350g - 800g - 1kg",
				"link":"cornetti-integrali-nocciola"
			},
			{
				"title": "Cornetti integrali frutti rossi",
				"image": "https://static.mulinobianco.it/v3/pew/COLLECTION_COLAZIONE_2022/assets/img/prodotti/cornetti_integrali_fruttirossi.png",
				"description": "350g - 800g - 1kg",
				"link":"cornetti-integrali-frutti-rossi"
			},
			{
				"title": "Cornetti SZA",
				"image": "https://static.mulinobianco.it/v3/pew/COLLECTION_COLAZIONE_2022/assets/img/prodotti/SZA_cornetti.png",
				"description": "350g - 800g - 1kg",
				"link":"cornetti-senza-zuccheri-aggiunti"
			},
			{
				"title": "Plumcake SZA",
				"image": "https://static.mulinobianco.it/v3/pew/COLLECTION_COLAZIONE_2022/assets/img/prodotti/plumcake_sza.png",
				"description": "350g - 800g - 1kg",
				"link":"plumcake-senza-zuccheri-aggiunti"
			},
			{
				"title": "Fette biscottate dorate",
				"image": "https://static.mulinobianco.it/v3/pew/COLLECTION_COLAZIONE_2022/assets/img/prodotti/fette_dorate.png",
				"description": "350g - 800g - 1kg",
				"link":"le-dorate"
			},
			{
				"title": "Fette biscottate rigate",
				"image": "https://static.mulinobianco.it/v3/pew/COLLECTION_COLAZIONE_2022/assets/img/prodotti/fette_rigate.png",
				"description": "350g - 800g - 1kg",
				"link":"fette-biscottate-rigate"
			},
			{
				"title": "Fette biscottate malto d'orzo",
				"image": "https://static.mulinobianco.it/v3/pew/COLLECTION_COLAZIONE_2022/assets/img/prodotti/fette_malto.png",
				"description": "350g - 800g - 1kg",
				"link":"le-malto-dorzo"
			},
			{
				"title": "Fette biscottate dolcifette",
				"image": "https://static.mulinobianco.it/v3/pew/COLLECTION_COLAZIONE_2022/assets/img/prodotti/fette_dolcifette.png",
				"description": "350g - 800g - 1kg",
				"link":"le-dolcifette"
			},
			{
				"title": "Fette biscottate ai cereali",
				"image": "https://static.mulinobianco.it/v3/pew/COLLECTION_COLAZIONE_2022/assets/img/prodotti/fette_cereali.png",
				"description": "350g - 800g - 1kg",
				"link":"le-cereali"
			},
			{
				"title": "Fette biscottate rustiche",
				"image": "https://static.mulinobianco.it/v3/pew/COLLECTION_COLAZIONE_2022/assets/img/prodotti/fette_rustiche.png",
				"description": "350g - 800g - 1kg",
				"link":"le-rustiche"
			},
			{
				"title": "Fette biscottate integrali",
				"image": "https://static.mulinobianco.it/v3/pew/COLLECTION_COLAZIONE_2022/assets/img/prodotti/fette_integrali.png",
				"description": "350g - 800g - 1kg",
				"link":"le-integrali"
			}
		]
	}
}